// initial state
const state = () => ({
    selectedMenuItemId: null,
    itemIdPrefix: "menu_item_",
    categoryIdPrefix: "menu_category_",
    rawMenu: null,
});

// getters
const getters = {};

// actions
const actions = {
    async getMenu({ commit }, slug) {
        return new Promise((resolve, reject) => {
            this.processing = true;
            axios.get("/api/menu/" + slug).then(
                (response) => {
                    if (response.data.id) {
                        commit("saveRawMenu", response.data);
                        resolve(response.data);
                    } else {
                        commit("saveRawMenu", null);
                        resolve(response.data);
                    }
                },
                (error) => {
                    commit("saveApiError", error, { root: true });
                    reject(error);
                }
            );
        });
    },
    refreshMenu({ dispatch, commit }, slug) {
        return new Promise((resolve, reject) => {
            dispatch("getMenu", slug).then(() => {
                resolve();
            });
        });
    },
    setSelectedMenuItemId({ commit }, id) {
        commit("saveSelectedMenuItemId", id);
    },
};
// mutations
const mutations = {
    saveRawMenu(state, menu) {
        state.rawMenu = menu;
    },
    saveSelectedMenuItemId(state, id) {
        state.selectedMenuItemId = id;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
